// extracted by mini-css-extract-plugin
export default {"deliveryDetails":"style_deliveryDetails__TF1lP","card":"style_card__Y0AVg","image":"style_image__UP6VD","detailsButton":"style_detailsButton__oAq+V"};